import { NgModule } from '@angular/core';
import { NgXCable, Broadcaster } from '@shared/services/action-cable.service';

@NgModule({
  providers: [NgXCable, Broadcaster]
})
export class NgXCableModule {}
